/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';
import type { ProfessionAndEnvironmentOfMom } from './ProfessionAndEnvironmentOfMom';
import {
    ProfessionAndEnvironmentOfMomFromJSON,
    ProfessionAndEnvironmentOfMomFromJSONTyped,
    ProfessionAndEnvironmentOfMomToJSON,
} from './ProfessionAndEnvironmentOfMom';

/**
 * 
 * @export
 * @interface ProfessionAndEnvironmentOfMomPagination
 */
export interface ProfessionAndEnvironmentOfMomPagination {
    /**
     * 
     * @type {Array<ProfessionAndEnvironmentOfMom>}
     * @memberof ProfessionAndEnvironmentOfMomPagination
     */
    data?: Array<ProfessionAndEnvironmentOfMom>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof ProfessionAndEnvironmentOfMomPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the ProfessionAndEnvironmentOfMomPagination interface.
 */
export function instanceOfProfessionAndEnvironmentOfMomPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProfessionAndEnvironmentOfMomPaginationFromJSON(json: any): ProfessionAndEnvironmentOfMomPagination {
    return ProfessionAndEnvironmentOfMomPaginationFromJSONTyped(json, false);
}

export function ProfessionAndEnvironmentOfMomPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfessionAndEnvironmentOfMomPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ProfessionAndEnvironmentOfMomFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function ProfessionAndEnvironmentOfMomPaginationToJSON(value?: ProfessionAndEnvironmentOfMomPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ProfessionAndEnvironmentOfMomToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

